/**
 * List component
 *
 * @ng-content: header
 * @param {array<string>} list : list  of strings
 * @param {string} type: value type
 **/

import _toString from 'lodash-es/toString';
import _findIndex from 'lodash-es/findIndex';

//Angular Core
import { Component, Input, Output, EventEmitter } from '@angular/core';

import { faEye, faEyeSlash, IconDefinition, faExclamation } from "@fortawesome/free-solid-svg-icons";

@Component({

    selector: 'list',
    templateUrl: 'list.component.html'
})
export class ListComponent {
    @Input()
    public listId: any;
    @Input()
    public isHeader: boolean = true;
    @Input()
    public list: any = {};
    @Input()
    public type: string = "string";
    @Input()
    public selectedIf: string;
    @Input()
    public disabledIf: string;
    @Input()
    public isError: string[];
    @Input()
    public showErrors: boolean = false;
    @Input()
    public m_viewDetailsFlag: boolean = false;

    @Input()
    public useApis: boolean = true;


    @Output()
    public removeItem: EventEmitter<string> = new EventEmitter();
    @Output()
    public showItemEvent: EventEmitter<string> = new EventEmitter();

    public m_viewDetailsBtn: boolean = false;

    public iconEye: IconDefinition = faEye;

    public iconEyeSlash: IconDefinition = faEyeSlash;

    public iconExclamation: IconDefinition = faExclamation;

    public m_list: any = [];
    public m_typeWithDetails: string[] = [
        'traveller',
        'travellersynchronyme'
    ];

    public ngOnInit(): void {
        this.setViewDetailsBtn();
        this.init();
    }


    /**
     * showTnr
     * show Tnr form Pnr list
     * event emiter
     * @param _event
     */
    public showTnr(_event: any): void {
        this.showItemEvent.emit(_toString(_event));
    }

    /**
     * removeMe
     * event emiter to remove an item form a list
     * @param {number} _id
     * @param _event
     */
    public removeMe(_id: number, _event: any): void {
        if (_event) {
            this.removeItem.emit(_toString(_event));
        }
    }

    /**
     * setViewDetails
     *
     * Display or not the "Details btn", depending on this.type
     */
    protected setViewDetailsBtn(): void {
        if (_findIndex(this.m_typeWithDetails, (o: string) => {
            return o === this.type;
        }) > -1) {
            this.m_viewDetailsBtn = true;
        }
    }

    /**
     * init
     *
     * to be over-writed by inherited components
     */
    protected init(): void {

    }



}
